module.exports = __webpack_public_path__ + "img/phone.4516d97e.svg";